var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"read-time"},[_c('i',{class:_vm.icon}),_vm._v(" "),(_vm.enableReadTimeText)?_c('span',{staticClass:"read-time-text"},[_vm._v("\n        "+_vm._s(_vm.$translate('read_time', 'Lästid'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"read-time-minutes"},[_vm._v("\n        "+_vm._s(_vm.$translate('wpm_read', '{readTime} min')
            .replace('{readTime}', _vm.formatReadMinutes))+" \n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }